import { Capacitor, registerPlugin } from '@capacitor/core'

export interface NativeScaleStatus {
  connected: boolean
  mode?: string
  port?: string
  protocol?: string
  baudRate?: number
  starting?: boolean
  error?: string
  weightKg?: number
  stable?: boolean
  raw?: string
  rawHex?: string
  lastAt?: number
  lastRawAt?: number
}

export interface NativeScaleReading {
  kg: number
  stable: boolean
  raw?: string
  protocol?: string
  at?: number
}

interface ScalesPlugin {
  start(): Promise<NativeScaleStatus>
  stop(): Promise<NativeScaleStatus>
  status(): Promise<NativeScaleStatus>
  listPorts(): Promise<{ ports: Array<{ path: string; readable: boolean; writable: boolean }> }>
  addListener(
    eventName: string,
    listener: (value: NativeScaleStatus | NativeScaleReading) => void
  ): Promise<{ remove: () => Promise<void> }>
}

const Scales = registerPlugin<ScalesPlugin>("Scales")

/** Native serial scales are available only in the Android build. */
export function isNativeScales(): boolean {
  return Capacitor.getPlatform() === "android"
}

export function nativeScalesStart(): Promise<NativeScaleStatus> {
  return Scales.start()
}

export function nativeScalesStop(): Promise<NativeScaleStatus> {
  return Scales.stop()
}

export function nativeScalesStatus(): Promise<NativeScaleStatus> {
  return Scales.status()
}

export function nativeScalesListPorts(): Promise<{
  ports: Array<{ path: string; readable: boolean; writable: boolean }>
}> {
  return Scales.listPorts()
}

export function nativeScalesOnStatus(
  listener: (status: NativeScaleStatus) => void
): Promise<{ remove: () => Promise<void> }> {
  return Scales.addListener("scaleStatus", (value) => {
    listener(value as NativeScaleStatus)
  })
}

export function nativeScalesOnWeight(
  listener: (reading: NativeScaleReading) => void
): Promise<{ remove: () => Promise<void> }> {
  return Scales.addListener("scaleWeight", (value) => {
    listener(value as NativeScaleReading)
  })
}
